import React from 'react';

interface WorkspaceRequiredProps {
  children: React.ReactNode;
}

const WorkspaceRequired: React.FC<WorkspaceRequiredProps> = ({ children }) => {
  // For now, just render the children directly
  // This can be enhanced later with workspace validation logic
  return <>{children}</>;
};

export default WorkspaceRequired; 